import { MealOfDayDivisionType, MealPart, MealDivisionTemp } from '@/api/types'
import { Tab, TabList, TabPanel, Tabs } from '@/components/Tabs'
import React from 'react'
import { useTranslation } from 'react-i18next'
import MealPartSelector from './MealPartSelector'
import IngredientSelector from './IngredientSelector'
import RecipeSelector from './RecipeSelector'

type Props = {
  onChange: (value: MealDivisionTemp | null) => void
}

export default function MealOfDayDivisionEditor({ onChange }: Props) {
  const { t } = useTranslation()
  const [mealDivisionType, setType] = React.useState<MealOfDayDivisionType>('MEAL_PART')

  function handleMealPartChange(value: MealPart) {
    onChange({ type: 'MEAL_PART', mealPart: value })
  }

  function handleIngredientChange(ingredient: { idIngredient: number; name: string }) {
    onChange({ type: 'INGREDIENT', ingredientDivision: { ingredient } })
  }

  function handleRecipeChange(recipe: { idRecipe: number; name: string }) {
    onChange({ type: 'RECIPE', recipe })
  }

  function handleTypeChange(key: MealOfDayDivisionType) {
    setType(key)
    onChange(null)
  }

  return (
    <div>
      <Tabs
        selectedKey={mealDivisionType}
        onSelectionChange={(key) => handleTypeChange(key as MealOfDayDivisionType)}>
        <TabList style={{ flexGrow: 1 }}>
          <Tab id={'MEAL_PART'}>{t(`mealOfDayDivision.types.MEAL_PART` as any)}</Tab>
          <Tab id={'INGREDIENT'}>{t(`mealOfDayDivision.types.INGREDIENT` as any)}</Tab>
          <Tab id={'RECIPE'}>{t(`mealOfDayDivision.types.RECIPE` as any)}</Tab>
        </TabList>

        <TabPanel id={'MEAL_PART'}>
          <MealPartSelector onSelectionChange={handleMealPartChange} />
        </TabPanel>
        <TabPanel id={'INGREDIENT'}>
          <IngredientSelector onSelectionChange={handleIngredientChange} />
        </TabPanel>
        <TabPanel id={'RECIPE'}>
          <RecipeSelector onSelectionChange={handleRecipeChange} />
        </TabPanel>
      </Tabs>
    </div>
  )
}
